import React from 'react'

import { AuthContext } from '../../contexts/AuthContext'
import { LocalStorage } from '../../services'
import { Header } from '../../components/Complex'
import MobileLogin from './MobileLogin'
import DesktopLogin from './DesktopLogin'
import moment from 'moment'

import './stylesL.css'
import RouterHook from '../../contexts/RouterHook'

/* eslint-disable react-hooks/exhaustive-deps */
export default function Login() {
  const serverRouter = RouterHook()
  const { sttAuthCtx, actionsAuth } = React.useContext(AuthContext)

  React.useEffect(() => {
    //Procura por url salva para redirecionar após o login
    const url = LocalStorage.get('url-selecionada')
    if (url) {
      // Se tiver um url, verificar se url.date é de pelo menos 3 horas atrás com moment().subtract(3, 'hours'), date está no formato 'YYYY-MM-DD HH:mm:ss'
      const date = url.date
      const now = moment()
      const then = moment(date, 'YYYY-MM-DD HH:mm:ss')
      if (now.diff(then, 'hours') > 3) {
        // Se for maior QUE 3 horas, remover url e redirecionar para a home
        LocalStorage.remove('url-selecionada')
      }
    }
    if (sttAuthCtx.isLogged) {
      actionsAuth.ValidarRefreshToken().then(res => {
        if (res.retorno) {
          serverRouter('home')
        }
      })
    }
  }, [])

  return (
    <div className='contain-max-center'>
      {sttAuthCtx.isMobile ? <></> : <Header.ContainH />}
      <div className='contain-mid-center'>
        {!sttAuthCtx.isMobile ? <DesktopLogin /> : <MobileLogin />}
      </div>
    </div>
  )
}
